module.exports = __webpack_public_path__ + "img/ico_giftcard_2.4fa01b6.svg";